// src/DevStreamView.js
import React from "react";
import DevStreamEventCard from "./DevStreamEventCard";
import "./DevStream.css";

/**
 * DevStreamView - Event list display
 *
 * Features:
 * - Scrollable event list
 * - Newest events at top
 * - Empty state message
 * - Renders DevStreamEventCard for each event
 */
const DevStreamView = ({ events, maxEvents }) => {
  if (events.length === 0) {
    return (
      <div className="dev-stream-view">
        <div className="empty-state">
          <div className="empty-state-icon">📭</div>
          <div className="empty-state-text">No events to display</div>
          <div className="empty-state-hint">
            Events from YP and MC will appear here in real-time
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dev-stream-view">
      <div className="event-count-header">
        {events.length} event{events.length !== 1 ? "s" : ""} (max {maxEvents})
      </div>

      <div className="event-list">
        {events.map((event) => (
          <DevStreamEventCard key={event.id} event={event} />
        ))}
      </div>
    </div>
  );
};

export default DevStreamView;
